import { List as i } from "@mui/material";
import { styled as o } from "./styled2.mjs";
const p = o(i)`
	display: flex;
	flex-direction: column;
	gap: ${({ theme: t }) => t.tokens.spacing[8]};
`;
export {
  p as List
};
//# sourceMappingURL=styles90.mjs.map
